var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluxTutorials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#7388F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5467 11.3092L7.75712 5.20735C7.55835 5.10437 7.33069 5.04815 7.09766 5.0445C6.86462 5.04085 6.63466 5.0899 6.43152 5.18658C6.23032 5.28175 6.06271 5.42056 5.94593 5.58871C5.82916 5.75686 5.76743 5.94829 5.76709 6.14332V18.3456C5.76861 18.6382 5.90737 18.9183 6.15287 19.1243C6.39838 19.3303 6.73053 19.4454 7.07632 19.4443C7.31767 19.4442 7.55433 19.3879 7.76039 19.2816L19.5467 13.1798C19.7362 13.0821 19.8927 12.9448 20.0014 12.7811C20.11 12.6174 20.1671 12.4329 20.1671 12.2452C20.1671 12.0575 20.11 11.8729 20.0014 11.7092C19.8927 11.5456 19.7362 11.4083 19.5467 11.3106V11.3092ZM7.07632 18.3325V6.15232L18.8455 12.2445L7.07632 18.3325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluxTutorials);
export default __webpack_public_path__ + "static/media/FluxTutorials.315cfdba0cc0930772dca8ff87d744df.svg";
export { ForwardRef as ReactComponent };